export function isInWebView() {
  // @ts-ignore
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /FBAN|FBAV|Instagram|Twitter|WebView|wv/.test(userAgent);
}
